import { InitialsField, InputSize } from '@hb/shared'
import { CSSProperties, forwardRef } from 'react'
import { InputElement, InputProps } from '../../../../types/fields'
import InputContainer from '../Shared/InputContainer'
import { INPUT_SIZE_TOKENS, useInputSize } from '../Shared/sizes'
import { TextInputElement } from '../Text/styles'

export const INITIALS_CONTAINER_WIDTH: Record<InputSize, string> = {
  xs: '60px',
  sm: '60px',
  md: '80px',
  lg: '90px',
}

const SCRIPT_FONT_SIZE: Record<InputSize, string> = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.2rem',
}

const getStyle = (size: InputSize, value: string): CSSProperties => ({
  fontSize: value ? SCRIPT_FONT_SIZE[size] : INPUT_SIZE_TOKENS[size].fontSize,
  height: 'auto',
  lineHeight: 1,
  fontFamily: value ? 'Dancing Script' : 'Open Sans',
  textAlign: 'center',
})

// const baseFlexProps: FlexProps = {
//   py: 2,
// }

const InitialsInput: InputElement<InitialsField> = forwardRef<
  HTMLInputElement,
  InputProps<InitialsField>
>((props, ref) => {
  const { field, input, disabled, readOnly, style, inputStyle } = props
  const size = useInputSize(props.size ?? field?.size)

  const { placeholder } = field ?? {}
  return (
    <InputContainer {...props} style={{ width: INITIALS_CONTAINER_WIDTH[size], ...style }}>
      <TextInputElement
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        maxLength={3}
        placeholder={placeholder}
        // height="auto"
        style={{ ...getStyle(size, input.value), ...inputStyle }}
        autoComplete={field.autocomplete}
        {...input}
      />
    </InputContainer>
  )
})

export default InitialsInput
